import PropTypes from 'prop-types';
import React from 'react';

export const WARN_DEFAULT_VARIANT = {
  border: { fill: '#B8B8B8' },
  exclamation: { fill: '#B8B8B8' },
  inner: { fill: '#FFF' },
};

export const WARN_VIBRANT_VARIANT = {
  border: { fill: '#FF5C45' },
  exclamation: { fill: '#FF5C45' },
  inner: { fill: '#FFF' },
};

export const WARN_STANDARD_VARIANT = {
  border: { fill: '#000' },
  exclamation: { fill: '#000' },
  inner: { fill: '#FDD237' },
};

const Warn = ({ size = '100%', variant = WARN_DEFAULT_VARIANT }) => (
  /* eslint-disable max-len */
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 34.4 30.8">
    <g>
      <path style={variant.inner} d="M31.9,25.6L19.3,3.7c-0.2-0.4-0.5-0.7-0.9-0.9c-0.8-0.4-1.8-0.4-2.5,0C15.5,3,15.2,3.3,15,3.7L2.4,25.5 c-0.5,0.8-0.4,1.6,0,2.4c0.2,0.4,0.5,0.6,0.9,0.9c0.4,0.2,0.8,0.3,1.2,0.3h25.2c0.4,0,0.9-0.1,1.2-0.3c0.4-0.2,0.7-0.5,0.9-0.9 C32.4,27.1,32.4,26.3,31.9,25.6z" />
      <path style={variant.border} d="M29.8,30H4.5c-0.6,0-1.1-0.1-1.7-0.4c-0.5-0.3-0.9-0.7-1.2-1.2c-0.6-1-0.7-2.2,0-3.3L14.2,3.2c0.3-0.5,0.7-0.9,1.2-1.2 c1-0.6,2.4-0.6,3.4,0c0.5,0.3,0.9,0.7,1.2,1.2l12.6,21.9c0.6,1.1,0.6,2.2-0.1,3.3c-0.3,0.5-0.7,0.9-1.2,1.2 C30.9,29.8,30.3,30,29.8,30z M17.1,3.3c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.4,0.3-0.6,0.6L3.1,26c-0.3,0.5-0.3,1,0,1.5 c0.1,0.2,0.3,0.4,0.6,0.5c0.3,0.1,0.5,0.2,0.8,0.2h25.2c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.6-0.5c0.3-0.5,0.3-1,0-1.5l0,0 L18.6,4.1c-0.1-0.2-0.3-0.4-0.6-0.6C17.7,3.4,17.4,3.3,17.1,3.3z" />
    </g>
    <g>
      <path style={variant.exclamation} d="M18.6,24.3v-1.8c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2h-1.9c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4 v1.8c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2h1.9c0.1,0,0.3-0.1,0.4-0.2C18.6,24.6,18.6,24.4,18.6,24.3z" />
      <path style={variant.exclamation} d="M18.6,19.7l0.3-8.6c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.3-0.2-0.4-0.2H16c-0.1,0-0.2,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.2,0.3l0.3,8.6c0,0.1,0.1,0.2,0.2,0.2C16,20,16.1,20,16.3,20H18c0.2,0,0.3,0,0.4-0.1 C18.5,19.9,18.6,19.8,18.6,19.7z" />
    </g>
  </svg>
  /* eslint-enable max-len */
);

Warn.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf([
    WARN_DEFAULT_VARIANT,
    WARN_VIBRANT_VARIANT,
    WARN_STANDARD_VARIANT,
  ]),
};

export default Warn;
